import { Box, Text } from 'ui'

export function EmptyState() {
  return (
    <Box>
      <Text textAlign="center" fontSize={2} fontWeight="500">
        Please select at least one location to view data.
      </Text>
    </Box>
  )
}
